import {
  ClientStatusesListListData,
  clientStatusesListListInfiniteOptions,
  Dropdown,
  PaginatedDropdownList,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect, RangePickerFilter } from '@crm/components'
import { defaultFiltersMultipleValues } from '@crm/utils'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { defaultFilters } from '@shared/utils'
import { Tooltip } from 'antd'

export const ClientFilters = () => {
  const { t } = useLocales()
  const { params, updateQuery } = useQueryUpdate()

  const createdByValue = defaultFiltersMultipleValues(params?.created_by)
  const statusValue = defaultFiltersMultipleValues(params?.status, true)

  return (
    <>
      <InfiniteSelect<
        ClientStatusesListListData,
        PaginatedDropdownList,
        Dropdown
      >
        value={statusValue}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('contacts.status')}
        getQueryFunction={clientStatusesListListInfiniteOptions}
        onChange={(status) =>
          updateQuery({ status, page: defaultFilters.page })
        }
        baseOptions={{
          query: {
            preference: params?.status
          }
        }}
        mode="multiple"
        maxTagCount={1}
        maxTagTextLength={6}
      />

      <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
        value={createdByValue}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('created_by')}
        getQueryFunction={usersListListInfiniteOptions}
        onChange={(created_by) =>
          updateQuery({ created_by, page: defaultFilters.page })
        }
        baseOptions={{
          query: {
            preference: params?.created_by
          }
        }}
        mode="multiple"
        maxTagCount={1}
        maxTagTextLength={6}
      />

      <Tooltip title={`${t('created_at_from')} - ${t('created_at_to')}`}>
        <RangePickerFilter
          fromParam="created_at_from"
          toParam="created_at_to"
          placeholder={[t('created_at_from'), t('created_at_to')]}
        />
      </Tooltip>
    </>
  )
}
